import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../Redux/Actions/index";
import {
  showErrorToastMessage,
  showSuccessToastMessage,
} from "../../../component/Toasts/Toasts";
import Select from "react-select";
import { Strings } from "../../../constant/Strings/index";
import "./TaskDetails.scss";
import "./style.scss";
import { Dropdown, Button, Spinner, InputGroup } from "react-bootstrap";
import { BsCheckLg, BsGear, BsXLg } from "react-icons/bs";
import Form from 'react-bootstrap/Form';
import ActivityTypeManagerModal from "../../../component/ModalComponent/ActivityTypeManagerModal";
import TaskNameManagerModal from "../../../component/ModalComponent/TaskNameManagerModal";
interface SelectOption {
  value: string;
  label: string;
}

interface ITaskDetailsState {
  taskName: string;
  activityType: string;
  clientId: string;
  subDepartmentId: string;
  employeeId: string;
  assignedHrbpId: string;
  priority: string | null;
  status: string;
  startDate: string;
  dueDate: string;
  comments: string;
}

interface IEditTaskProps {
  taskId: string | null;
  hideEditModal: () => void;
  onUpdateSuccess: () => void;
}

const EditTask = (props: IEditTaskProps) => {
  const { taskId, hideEditModal, onUpdateSuccess } = props;
  const dispatch = useDispatch();

  const HR_ADMIN_ROLE = 'hr-admin';
  const isHrAdmin = (localStorage.getItem("role") || "").includes(HR_ADMIN_ROLE);

  const { getEmployeeData, getClientNameDetails, getHrbpActivityById } = useSelector(
    (state: any) => state.employeeReducer
  );
  const { hrbpTaskNamesByActivity } = useSelector(
    (state: any) => state.employeeReducer
  );
  const { allHrbpActivityTypes } = useSelector(
    (state: any) => state.employeeReducer
  );

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [taskOptions, setTaskOptions] = useState<any[]>([]);
  const [isAddingNewTask, setIsAddingNewTask] = useState(false);
  const [newTaskName, setNewTaskName] = useState("");
  const [isSubmittingNewTask, setIsSubmittingNewTask] = useState(false);
  const [activityTypeOptions, setActivityTypeOptions] = useState<any[]>([]);
  const [isAddingNewActivityType, setIsAddingNewActivityType] = useState(false);
  const [newActivityTypeName, setNewActivityTypeName] = useState("");
  const [isSubmittingNewActivityType, setIsSubmittingNewActivityType] = useState(false);
  const [showActivityManager, setShowActivityManager] = useState(false);
  const [showTaskManager, setShowTaskManager] = useState(false);
  const [justReassigned, setJustReassigned] = useState(false);
  const [hasFetchedTasks, setHasFetchedTasks] = useState(false);
  
  const [taskDetails, setTaskDetails] = useState<ITaskDetailsState>({
    taskName: "",
    activityType: "",
    clientId: "",
    subDepartmentId: "",
    employeeId: "",
    assignedHrbpId: "",
    priority: null,
    status: "",
    startDate: "",
    dueDate: "",
    comments: "",
  });

  const [taskNameOptions, setTaskNameOptions] = useState<string[]>([]);

  useEffect(() => {
    if (taskDetails.activityType) {
      setHasFetchedTasks(false); // <--- START LOADING
      dispatch(actions.getHrbpTasksByActivityTypeAction(taskDetails.activityType) as any);
    }
  }, [taskDetails.activityType, dispatch]);

  useEffect(() => {
    if (hrbpTaskNamesByActivity && hrbpTaskNamesByActivity.data) {
      setTaskOptions(hrbpTaskNamesByActivity.data);
      setHasFetchedTasks(true);
    } else {
      setTaskOptions([]);
      if (hrbpTaskNamesByActivity) setHasFetchedTasks(true);
    }
  }, [hrbpTaskNamesByActivity]);

  useEffect(() => {
    if (allHrbpActivityTypes && allHrbpActivityTypes.data) {
      setActivityTypeOptions(allHrbpActivityTypes.data);
    }
  }, [allHrbpActivityTypes]);

  const [isFieldsDisabled, setIsFieldsDisabled] = useState(false);

  const [errors, setErrors] = useState({ taskName: "", startDate: "", dueDate: "", comments: "" });

  useEffect(() => {
    dispatch(actions.getEmployeeDataAction());
    dispatch(actions.getClientNameAction());
    dispatch(actions.getAllHrbpActivityTypesAction() as any);
    if (taskId) {
      dispatch(actions.getHrbpActivityByIdAction(taskId));
    }
  }, [dispatch, taskId]);

  useEffect(() => {
    const taskData = getHrbpActivityById?.data;
    if (taskData) {
      setTaskDetails({
        taskName: taskData.taskName || "",
        activityType: taskData.activityType || "",
        clientId: taskData.clientId || "",
        subDepartmentId: taskData.subDepartmentId || "",
        employeeId: taskData.employeeId || "",
        assignedHrbpId: taskData.assignedHrbpId || "",
        priority: taskData.priority || null,
        status: taskData.status || "",
        startDate: taskData.startDate ? new Date(taskData.startDate).toISOString().split('T')[0] : "",
        dueDate: taskData.dueDate ? new Date(taskData.dueDate).toISOString().split('T')[0] : "",
        comments: taskData.comments || "",
      });
      if (taskData.employeeId) {
        setIsFieldsDisabled(true);
      }
    }
  }, [getHrbpActivityById]);

  useEffect(() => {
    if (taskDetails.activityType && activityTypeOptions.length > 0) {
      const exists = activityTypeOptions.some((op: any) => op.name === taskDetails.activityType);
      if (!exists) {
        setTaskDetails(prev => ({ ...prev, activityType: "", taskName: "" }));
      }
    }
  }, [activityTypeOptions, taskDetails.activityType]);

 useEffect(() => {
    if (taskDetails.taskName && taskOptions.length > 0 && hasFetchedTasks) {
      
      const exists = taskOptions.some((op: any) => op.name === taskDetails.taskName);
      if (!exists && !justReassigned) {
        setTaskDetails(prev => ({ ...prev, taskName: "" }));
      }
    }
    if (justReassigned && hasFetchedTasks) {
        const exists = taskOptions.some((op: any) => op.name === taskDetails.taskName);
        if(exists) setJustReassigned(false);
    }
  }, [taskOptions, taskDetails.taskName, justReassigned, hasFetchedTasks]);

  const employeeOptions: SelectOption[] = (getEmployeeData?.data || []).map((emp: any) => ({
    value: emp._id, label: `${emp.candidateName} ${emp.lastname || ""} - ${emp.employeeId}`,
  }));

  const clientOptions: SelectOption[] = (getClientNameDetails?.data || []).map((client: any) => ({
    value: client._id, label: client.clientName,
  }));

  const hrbpOptions: SelectOption[] = (getEmployeeData?.data || []).map((emp: any) => ({
    value: emp._id,
    label: `${emp.candidateName} ${emp.lastname || ""} - ${emp.employeeId}`,
  }));

  const handleAddNewTask = () => {
    if (!newTaskName.trim()) { showErrorToastMessage("Please enter a name."); return; }
    setIsSubmittingNewTask(true);
    dispatch(actions.createNewTaskForActivityTypeAction(taskDetails.activityType, newTaskName, (res: any) => {
      setIsSubmittingNewTask(false);
      if (res?.data || res?.code === 200) {
        const createdName = res?.data?.name || newTaskName;
        setTaskOptions(prev => [...prev, { name: createdName, _id: res?.data?._id }]);
        setTaskDetails(prev => ({ ...prev, taskName: createdName }));
        setErrors(prev => ({ ...prev, taskName: "" }));
        setNewTaskName("");
        setIsAddingNewTask(false);
      } else {
        showErrorToastMessage(res?.error?.error_description || "Failed to add new task");
      }
    }) as any);
  };

  const handleAddNewActivityType = () => {
    if (!newActivityTypeName.trim()) { showErrorToastMessage("Please enter a name."); return; }
    setIsSubmittingNewActivityType(true);
    dispatch(actions.createNewHrbpActivityTypeAction(newActivityTypeName, (res: any) => {
      setIsSubmittingNewActivityType(false);
      if (res?.data || res?.code === 200) {
        const createdName = res?.data?.name || newActivityTypeName;
        setActivityTypeOptions(prev => [...prev, { name: createdName, _id: res?.data?._id }]);
        setTaskDetails(prev => ({ ...prev, activityType: createdName, taskName: "" }));
        setNewActivityTypeName("");
        setIsAddingNewActivityType(false);
        dispatch(actions.getAllHrbpActivityTypesAction() as any);
      } else {
        showErrorToastMessage(res?.error?.error_description || "Failed to add new activity type");
      }
    }) as any);
  };
  const handleEmployeeChange = (selectedOption: SelectOption | null) => {
    if (selectedOption) {
      const selectedEmployeeId = selectedOption.value;
      const fullEmployee = (getEmployeeData?.data || []).find(
        (e: any) => e._id === selectedEmployeeId
      );

      if (fullEmployee) {
        const matchingClient = clientOptions.find(
          (c: SelectOption) => c.label === fullEmployee.clientName
        );
        setTaskDetails({
          ...taskDetails,
          employeeId: fullEmployee._id,
          clientId: matchingClient ? matchingClient.value : "",
          subDepartmentId: fullEmployee.subDepartment || "",
          assignedHrbpId: fullEmployee.hrbpRef || "",
        });
        setIsFieldsDisabled(true);
      }
    } else {
      setTaskDetails({
        ...taskDetails,
        employeeId: "", clientId: "", subDepartmentId: "", assignedHrbpId: "",
      });
      setIsFieldsDisabled(false);
    }
  };

  // --- ADDED: Function to handle input changes and clear errors ---
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    setTaskDetails(prevDetails => ({
      ...prevDetails,
      [name]: value,
    }));

    const errorKey = name as keyof typeof errors;
    if (errors[errorKey]) {
      setErrors(prevErrors => ({
        ...prevErrors,
        [name]: "",
      }));
    }
  };
  // --- MODIFIED: Updated validation logic to include length checks ---
  const validate = () => {
    let isValid = true;
    const newErrors = { taskName: "", startDate: "", dueDate: "", comments: "" };

    if (!taskDetails.taskName.trim()) {
      newErrors.taskName = "Task Name is required";
      isValid = false;
    }
    if (taskDetails.comments.length > 500) {
      newErrors.comments = "Comments cannot exceed 500 characters.";
      isValid = false;
    }
    if (!taskDetails.startDate) {
      newErrors.startDate = "Start Date is required";
      isValid = false;
    }
    if (!taskDetails.dueDate) {
      newErrors.dueDate = "Due Date is required";
      isValid = false;
    }

    const currentYear = new Date().getFullYear();
    const maxYear = currentYear + 50;
    if (taskDetails.startDate) {
      const startYear = new Date(taskDetails.startDate).getFullYear();
      if (startYear < 2000 || startYear > maxYear) {
        newErrors.startDate = `Please enter a year between 2000 and ${maxYear}.`
        isValid = false;
      }
    }
    if (taskDetails.dueDate) {
      const dueYear = new Date(taskDetails.dueDate).getFullYear();
      if (dueYear < 2000 || dueYear > maxYear) {
        newErrors.dueDate = `Please enter a year between 2000 and ${maxYear}.`
        isValid = false;
      }
    }
    if (taskDetails.startDate && taskDetails.dueDate) {
      const start = new Date(taskDetails.startDate);
      const due = new Date(taskDetails.dueDate);
      if (due < start) {
        newErrors.dueDate = "Due Date cannot be earlier than Start Date";
        isValid = false;
      }
    }
    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validate()) {
      setIsSubmitting(true);
      dispatch(
        actions.updateHrbpActivityAction(taskId, taskDetails, (res: any) => {
          setIsSubmitting(false);
          if (res?.error) {
            showErrorToastMessage(res.error.error_description || "Failed to update task");
          } else if (res?.code === 200) {
            showSuccessToastMessage("Task updated successfully!");
            onUpdateSuccess();

            hideEditModal();
          }
        })
      );
    }
  };

  const { cancel } = Strings;

  return (
    <div className="container">
      <div className="row g-3">
        {/* Row 1 */}
        <div className="col-md-6">
          <label className="form-label">Activity Type<span className="required">*</span></label>
          {isAddingNewActivityType ? (
            <InputGroup className="task-name-dropdown">
              <Form.Control
                placeholder="Enter new activity type"
                value={newActivityTypeName}
                onChange={(e: any) => setNewActivityTypeName(e.target.value)}
                autoFocus
                onKeyDown={(e: any) => e.key === 'Enter' && handleAddNewActivityType()}
              />
              <Button
                variant="primary"
                onClick={handleAddNewActivityType}
                disabled={isSubmittingNewActivityType || !newActivityTypeName.trim()}
                className="d-flex align-items-center justify-content-center"
              >
                {isSubmittingNewActivityType ? <Spinner animation="border" size="sm" /> : <BsCheckLg />}
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => setIsAddingNewActivityType(false)}
                className="pe-2 d-flex align-items-center justify-content-center"
              >
                <BsXLg />
              </Button>
            </InputGroup>
          ) : (
            <div className="task-name-dropdown">
              <Dropdown
                onSelect={(key: any) => {
                  if (key === "__ADD__") setIsAddingNewActivityType(true);
                  else setTaskDetails({ ...taskDetails, activityType: key });
                }}
              >
                <Dropdown.Toggle
                  variant="light"
                  className="w-100 text-start d-flex justify-content-between align-items-center"
                >
                  <span className="dropdown-text-label">
                    {taskDetails.activityType || "Select an activity..."}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100">
                  {isHrAdmin && (
                    <>
                      <Dropdown.Item eventKey="__ADD_NEW_ACTIVITY_TYPE__" className="add-new-task-option">
                        + Add new activity type...
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => setShowActivityManager(true)}
                        className="text-secondary">
                        <BsGear /> Manage Activity Types
                      </Dropdown.Item>
                      <Dropdown.Divider />
                    </>
                  )}
                  {activityTypeOptions.length > 0 ? (
                    activityTypeOptions.map((type: any, index: number) => (
                      <Dropdown.Item key={index} eventKey={type.name}>{type.name}</Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item disabled>Loading activities...</Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
        </div>
        <div className="col-md-6">
          <label className="form-label">Task Name<span className="required">*</span></label>

          {isAddingNewTask ? (
            <InputGroup className="task-name-dropdown">
              <Form.Control
                placeholder="Enter new task name"
                value={newTaskName}
                onChange={(e: any) => setNewTaskName(e.target.value)}
                autoFocus
                onKeyDown={(e: any) => e.key === 'Enter' && handleAddNewTask()}
              />
              <Button
                variant="primary"
                onClick={handleAddNewTask}
                disabled={isSubmittingNewTask || !newTaskName.trim()}
                className="d-flex align-items-center justify-content-center"
              >
                {isSubmittingNewTask ? <Spinner animation="border" size="sm" /> : <BsCheckLg />}
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => setIsAddingNewTask(false)}
                className="pe-2 d-flex align-items-center justify-content-center"
              >
                <BsXLg />
              </Button>
            </InputGroup>
          ) : (
            <div className="task-name-dropdown">
              <Dropdown
                onSelect={(key: any) => {
                  if (key === "__ADD_NEW__") {
                    setIsAddingNewTask(true);
                  } else {
                    setTaskDetails({ ...taskDetails, taskName: key });
                    setErrors({ ...errors, taskName: "" });
                  }
                }}
              >
                <Dropdown.Toggle
                  variant="light"
                  className="w-100 text-start d-flex justify-content-between align-items-center"
                  disabled={!taskDetails.activityType}
                >
                  <span className="dropdown-text-label">
                    {taskDetails.taskName || "Select a task..."}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100">
                  {isHrAdmin && (
                    <>
                      <Dropdown.Item eventKey="__ADD_NEW__" className="add-new-task-option">
                        + Add new task...
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => setShowTaskManager(true)}
                        className="text-secondary"><BsGear />
                        Manage Tasks
                      </Dropdown.Item>
                      <Dropdown.Divider />
                    </>
                  )}
                  {taskOptions.length > 0 ? (
                    taskOptions.map((task: any, index: number) => (
                      <Dropdown.Item key={index} eventKey={task.name}>{task.name}</Dropdown.Item>
                    ))
                  ) : (
                    <Dropdown.Item disabled>No predefined tasks found</Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          )}
          {errors.taskName && <p className="error">{errors.taskName}</p>}
        </div>

        {/* Row 2: Employee Selection */}
        <div className="col-md-12 mt-3">
          <label className="form-label">Employee</label>
          <Select
            options={employeeOptions}
            value={employeeOptions.find((e: SelectOption) => e.value === taskDetails.employeeId)}
            onChange={handleEmployeeChange}
            isClearable
          />
        </div>

        {/* Row 3: Client, Sub-Department, Assigned HRBP */}
        <div className="col-md-4 mt-3">
          <label className="form-label">Client</label>
          <Select
            options={clientOptions}
            value={clientOptions.find((c: SelectOption) => c.value === taskDetails.clientId)}
            onChange={(selected: any) => setTaskDetails({ ...taskDetails, clientId: selected.value })}
            isDisabled={isFieldsDisabled}
            placeholder={isFieldsDisabled ? "No Assigned Client" : "Select..."}
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">Sub-Department</label>
          <input
            type="text"
            className="form-control"
            value={taskDetails.subDepartmentId || (isFieldsDisabled ? "No Sub-Department" : "")}
            disabled
            style={{ fontStyle: !taskDetails.subDepartmentId && isFieldsDisabled ? 'italic' : 'normal' }}
          />
        </div>
        <div className="col-md-4 mt-3">
          <label className="form-label">Assigned HRBP</label>
          <Select
            options={hrbpOptions}
            value={hrbpOptions.find((h: SelectOption) => h.value === taskDetails.assignedHrbpId)}
            onChange={(selected: any) => setTaskDetails({ ...taskDetails, assignedHrbpId: selected.value })}
            isDisabled={isFieldsDisabled}
            placeholder={isFieldsDisabled ? "No Assigned HRBP" : "Select..."}
          />
        </div>

        {/* Row 4: Start Date and Due Date */}
        <div className="col-md-6 mt-3">
          <label className="form-label">Start Date<span className="required">*</span></label>
          <input type="date" className="form-control" value={taskDetails.startDate} onChange={(e) => setTaskDetails({ ...taskDetails, startDate: e.target.value })} />
          {errors.startDate && <p className="error">{errors.startDate}</p>}
        </div>
        <div className="col-md-6 mt-3">
          <label className="form-label">Due Date<span className="required">*</span></label>
          <input type="date" className="form-control" value={taskDetails.dueDate} onChange={(e) => setTaskDetails({ ...taskDetails, dueDate: e.target.value })} />
          {errors.dueDate && <p className="error">{errors.dueDate}</p>}
        </div>

        {/* Row 5: Priority (Non-mandatory) & Status */}
        <div className="col-md-6 mt-3">
          <label className="form-label">Priority</label>
          <Dropdown
            onSelect={(key: string | null) => {
              setTaskDetails({ ...taskDetails, priority: key === "" ? null : key });
            }}
          >
            <Dropdown.Toggle variant="light" className="w-100 text-start d-flex justify-content-between align-items-center">
              {taskDetails.priority || "Select..."}
            </Dropdown.Toggle>
            <Dropdown.Menu className="w-100">
              <Dropdown.Item eventKey="">None</Dropdown.Item>
              <Dropdown.Item eventKey="Low">Low</Dropdown.Item>
              <Dropdown.Item eventKey="Medium">Medium</Dropdown.Item>
              <Dropdown.Item eventKey="High">High</Dropdown.Item>
              <Dropdown.Item eventKey="Urgent">Urgent</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-6 mt-3">
          <label className="form-label">Status<span className="required">*</span></label>
          <Dropdown onSelect={(key: any) => setTaskDetails({ ...taskDetails, status: key })}>
            <Dropdown.Toggle variant="light" className="w-100 text-start d-flex justify-content-between align-items-center">{taskDetails.status}</Dropdown.Toggle>
            <Dropdown.Menu className="w-100">
              <Dropdown.Item eventKey="Open">Open</Dropdown.Item>
              <Dropdown.Item eventKey="Closed">Closed</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* --- MODIFIED: Comments textarea --- */}
        <div className="col-md-12 mt-3">
          <label className="form-label">Comments</label>
          <textarea
            className="form-control"
            name="comments"
            value={taskDetails.comments}
            onChange={handleInputChange}
            maxLength={500}
          ></textarea>
          <div className="d-flex justify-content-between">
            {errors.comments && <p className="error mb-0">{errors.comments}</p>}
            <small style={{ marginLeft: 'auto', color: '#6c757d', fontSize: '12px' }}>
              {taskDetails.comments.length} / 500
            </small>
          </div>
        </div>
      </div>

      <div className="modal-btn-wrapper mt-5 mx-auto">
        <div>
          <button className="btn cancel-btn buttonsize" onClick={hideEditModal}>{cancel}</button>
        </div>
        <div>
          <Button className="add-submit-button buttonsize" onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                <span className="ms-2">Saving...</span>
              </>
            ) : (
              "Save Changes"
            )}
          </Button>
        </div>
      </div>
      <ActivityTypeManagerModal
        show={showActivityManager}
        onHide={() => setShowActivityManager(false)}
        data={activityTypeOptions.map((d: any) => ({ _id: d._id, name: d.name }))}
        refreshData={() => dispatch(actions.getAllHrbpActivityTypesAction() as any)}
      />

      <TaskNameManagerModal
        show={showTaskManager}
        onHide={() => setShowTaskManager(false)}
        data={taskOptions.map((d: any) => ({ _id: d._id, name: d.name }))}
        allTasksOptions={taskOptions.map((d: any) => ({ value: d._id, label: d.name }))}
        refreshData={() => {
          if (taskDetails.activityType) {
            dispatch(actions.getHrbpTasksByActivityTypeAction(taskDetails.activityType) as any);
          }
        }}
        onReassignSuccess={(oldId: string, newTarget: any) => {
          setJustReassigned(true);
          setHasFetchedTasks(false);
          const fullLabel = newTarget.label;
          const matches = fullLabel.match(/^(.*) \((.*)\)$/);

          let taskName = fullLabel;
          let activityType = "";

          if (matches && matches.length >= 3) {
            taskName = matches[1];
            activityType = matches[2];
          }

          console.log(`Reassigning to: Task=[${taskName}] Type=[${activityType}]`);
          setTaskDetails(prev => ({
            ...prev,
            taskName: taskName,
            activityType: activityType || prev.activityType
          }));
          if (activityType) {
            dispatch(actions.getHrbpTasksByActivityTypeAction(activityType) as any);
          }
        }}
      />
    </div>
  );
};
export default EditTask;